import { FaCheckCircle } from "react-icons/fa";
import image from '../../../Assets/host_charger/resturants-c.webp'

export default function EVValueSection() {
    const items = [
        "Differentiate your property from competitors",
        "Attract and retain desirable residents",
        "Get an excellent ROI",
        "Turn your parking spots into profit centers",
    ];

    return (
        <section className="max-w-6xl mx-auto px-4 py-12 blade-margin-top-sm ">
            <div className="2xl:pb-20 xl:pb-16 pb-12">
                <h3 className="text-center font-gilroy">
                    Attract residents and <b> increase </b> your <b> property </b> value by providing a <b> premium </b> EV charging experience
                </h3>
            </div>

            <div className="flex flex-col md:flex-row bg-grey rounded-3xl overflow-hidden">
                {/* Left Text Column */}
                <div className="w-full md:w-1/2 p-6 sm:p-10 flex flex-col justify-center space-y-6">
                    {items.map((text, idx) => (
                        <div key={idx} className="flex items-start space-x-4">
                            <FaCheckCircle className="text-verde w-6 h-6 mt-1" />
                            <p className="text-gray-800 font-poppins">{text}</p>
                        </div>
                    ))}
                </div>

                {/* Right Image Column */}
                <div className="w-full md:w-1/2">
                    <img
                        src={image}
                        alt="EV Charger and Residents"
                        className="w-full h-full object-cover"
                    />
                </div>
            </div>
        </section>
    );
}
